import PhoneArea from "components/PhonePreview/PhoneArea"
import React from "react"

const Preview = ({
  menu_bg_color,
  menu_font_color,
  label = "",
  webLinkScreenType = "1",
  multiWebLinks = [],
  menuIcons = [],
}) => {
  return (
    <PhoneArea>
      <div
        style={{
          backgroundColor: "white",
          width: "105%",
          height: "105%",
          backgroundSize: "cover",
          marginLeft: "-5px",
          backgroundPosition: "center center",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "50px",
            backgroundColor: menu_bg_color,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            borderBottom: "1px solid white",
          }}
        >
          <p
            style={{
              textAlign: "center",
              paddingBlockStart: "1em",
              color: menu_font_color,
            }}
          >
            {label}
          </p>
        </div>
        {webLinkScreenType === "2" && (
          <div style={{ display: "flex", width: "100%" }}>
            {multiWebLinks.map((item, index) => (
              <div
                key={index}
                style={{
                  backgroundColor: menu_bg_color,
                  width: "100%",
                  height: "60px",
                  color: "white",
                  textAlign: "center",
                  borderRight: "1px solid white",
                }}
              >
                <img
                  src={menuIcons?.find(x => x?.id == item?.linkIcon)?.url || ""}
                  style={{
                    width: "30px",
                    height: "auto",
                    margin: "4px",
                  }}
                />
                <p>{item?.name}</p>
              </div>
            ))}
          </div>
        )}
        <div
          style={{
            width: "100%",
            height: "40px",
            position: "absolute",
            bottom: "0",
            left: "0",
            backgroundColor: menu_bg_color,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div className="pt-2">
            <i className="bx bx-chevron-left font-size-24" />
            <i className="bx bx-chevron-right font-size-24" />
          </div>
          <div className="pt-2 pe-2">
            <i className="bx bx-revision font-size-24" />
          </div>
        </div>
      </div>
    </PhoneArea>
  )
}

export default Preview
